import React from 'react'
import { Form } from 'semantic-ui-react'

const TextFilter = (props) => <Form.Input {...props} />

TextFilter.propTypes = {
  required: React.PropTypes.bool,
}

export default TextFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/TextFilter.js